import { categoryNavigation } from './navigation.js';

const shortLabels = {
  apps:'التطبيقات', websites:'المواقع', programs:'البرامج', products:'المنتجات',
  media:'الإصدارات', broadcasts:'القنوات', research:'البحوث', centers:'المراكز',
  children:'الأطفال', competitions:'المسابقات', exhibitions:'المعارض'
};

export const searchSections = categoryNavigation.map(item => ({
  id:item.id,
  type:item.type,
  label:shortLabels[item.id] || item.label,
  fullLabel:item.label,
  icon:item.icon
}));

export const quickSearchSections = ['websites','apps','research','centers']
  .map(id => searchSections.find(item => item.id === id));

export const searchSectionById = Object.fromEntries(searchSections.map(item => [item.id,item]));
export const searchSectionByType = Object.fromEntries(searchSections.map(item => [item.type,item]));
export const isSearchSection = value => !value || Boolean(searchSectionById[value]);

